import BigNumber from "bignumber.js";

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 18,
  FORMAT: {
    prefix: "",
    decimalSeparator: ".",
    groupSeparator: ",",
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: " ",
    fractionGroupSize: 0,
    suffix: "",
  },
});

export const formatNumber = (
  num: number | string,
  fixedNum = 8,
  round = true
) => {
  if (typeof num !== "number" && typeof num !== "string") {
    return "-";
  }

  if (typeof num === "number") {
    num = num.toString();
  }

  const bigNum = new BigNumber(num);

  if (bigNum.isNaN()) {
    return "-";
  }

  if (num === "0") {
    return "0";
  }

  let result = bigNum.toFormat(fixedNum);

  if (!round) {
    return result;
  }

  while (
    result.split(".")[1].length > 0 &&
    result.split(".")[1].slice(-1) === "0"
  ) {
    result = result.slice(0, -1);
  }

  if(result.split(".")[1].length === 0) {
    result = result.slice(0, -1);
  }

  return result;
};

export const unformatNumber = (num: string) => {
  const dec = num.split('.')
  if (dec.length > 2) {
    num = dec.slice(0, 2).join('.')
  }
  return num.split('').filter((char: string) => "1234567890.".includes(char)).join('');
};

export const numberParserForInput = (value: string) => {
  if (value === "-") return "-";
  let fixedNum = value.split(".")[1]?.length ?? 0;
  let result = formatNumber(
    value.replaceAll(",", "").replaceAll("-", ""),
    fixedNum,
    false
  );
  if (result === "-") return "";
  if (value[0] === "-") {
    result = "-" + result;
  }
  if (value.slice(-1) === ".") {
    result = result + ".";
  }
  return result;
};
